module.exports = __webpack_public_path__ + "static/media/20ECE25.9c83685a.jpg";